import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
    IStatusCountItem,
    isUnusualStatusLabel,
} from 'src/app/shared/helpers/consolidate-shipment-status-groups.util';
import { DeliveryStatusLabelPipe } from 'src/app/shared/pipes/delivery-status-label.pipe';

export interface IStatusStatsDialogData {
    statusCounts: IStatusCountItem[];
}

@Component({
    selector: 'eci-consolidate-shipment-status-stats-dialog',
    templateUrl: './consolidate-shipment-status-stats-dialog.component.html',
    styleUrls: ['./consolidate-shipment-status-stats-dialog.component.scss']
})
export class ConsolidateShipmentStatusStatsDialogComponent {

    private readonly deliveryStatusLabel = new DeliveryStatusLabelPipe();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IStatusStatsDialogData,
    ) {}

    getLabel(item: IStatusCountItem): string {
        if (item.label) {
            return item.label;
        }
        if (item.status === undefined || item.status === null) {
            return '';
        }
        return this.deliveryStatusLabel.transform(item.status);
    }

    isUnusual(item: IStatusCountItem): boolean {
        return isUnusualStatusLabel(this.getLabel(item));
    }
}
